import { render, staticRenderFns } from "./objinput.vue?vue&type=template&id=732bc378&scoped=true"
import script from "./objinput.vue?vue&type=script&lang=js"
export * from "./objinput.vue?vue&type=script&lang=js"
import style0 from "./objinput.vue?vue&type=style&index=0&id=732bc378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732bc378",
  null
  
)

export default component.exports